<template>
  <div
    role="button"
    tabindex="0"
    :class="[
      'rounded-lg border border-solid px-4 py-2',
      `resource-card-${resource.id}`,
      selected ? '!border-primary-600' : 'border-gray-300'
    ]"
    @click="emit('select')"
    @keydown.enter="emit('select')"
  >
    <slot>
      <ResourceContent :resource="resource" :link="false" />
    </slot>
  </div>
</template>

<script setup lang="ts">
import { ResourceAPIResponse, TimelineResource } from "@/typings/scheduler";
import ResourceContent from "./ResourceContent.vue";

// One selectable resource card, shared by the phone card stack and the picker
// sheet, so the `.resource-card-<id>` hook and the selected border live here.
// The default body is the technician card; a slot replaces it for Unassigned.
defineProps<{
  resource: ResourceAPIResponse | TimelineResource;
  selected: boolean;
}>();

const emit = defineEmits<{
  (e: "select"): void;
}>();
</script>
